module.exports = __webpack_public_path__ + "static/media/1.836eb50f.png";